//хук валидации фильтров грида для поиска всех позиций в плагинах для материальных отчетов для множественного выбора
//ref #94787 Добавить множественный выбор в некоторые плагины. 

import { useMemo } from 'react';

interface IGridColumnFilter {
    name: string;
    operator: string;
    value: any;
}

interface GridFilter {
    expression?: string;
    columnFilters?: IGridColumnFilter[];
}

interface UseGridFilterValidation {
    isSearchModeExpression: boolean;
    isSearchModeColumnFilter: boolean;
    hasFilter: boolean;
}

const MIN_SEARCH_LENGTH = 3;

export const useGridFilterValidation = (gridFilter: GridFilter): UseGridFilterValidation => {
    const isValidExpression = (expression: any): boolean => {
        return expression !== undefined &&
            expression !== null &&
            expression !== '' &&
            typeof expression === 'string' &&
            expression.trim().length >= MIN_SEARCH_LENGTH;
    };

    const isValidColumnFilter = (columnFilters: IGridColumnFilter[]): boolean => {
        return Array.isArray(columnFilters) && 
               columnFilters.some(cf => cf.name && cf.name !== 'deleted');
    };

    const isSearchModeExpression = useMemo(() => 
        isValidExpression(gridFilter?.expression), 
        [gridFilter?.expression]
    );

    const isSearchModeColumnFilter = useMemo(() => 
        isValidColumnFilter(gridFilter?.columnFilters || []), 
        [gridFilter?.columnFilters]
    );

    const hasFilter = useMemo(() => 
        isSearchModeColumnFilter || isSearchModeExpression, 
        [isSearchModeColumnFilter, isSearchModeExpression]
    );

    return {
        isSearchModeExpression,
        isSearchModeColumnFilter,
        hasFilter
    };
};